/* XENITH CORE 入荷優先案内ページ
   - 二重送信防止(送信中はボタン無効+「送信中…」)
   - 送信後の完了/エラー表示へフォーカス移動(スクリーンリーダー・キーボード対応)
   依存ライブラリなし・このページ専用 */
(function () {
  'use strict';
  if (window.__xcPriorityInit) return;
  window.__xcPriorityInit = true;

  function init() {
    var page = document.querySelector('[data-xc-priority]');
    if (!page || page.dataset.xcpBound) return;
    page.dataset.xcpBound = '1';

    var form = page.querySelector('[data-xc-priority-form]');
    var submitBtn = page.querySelector('[data-xc-priority-submit]');
    if (form && submitBtn) {
      form.addEventListener('submit', function () {
        /* HTML側のrequired検証を通過した送信のみここに来る */
        if (submitBtn.disabled) return;
        submitBtn.disabled = true;
        var label = submitBtn.querySelector('span');
        if (label) label.textContent = '送信中…';
      });
    }

    /* LPのSOLD OUTボタン等から ?color=BLACK で遷移した場合は希望カラーを自動選択 */
    try {
      var colorParam = new URLSearchParams(location.search).get('color');
      var colorSel = page.querySelector('#xcp-color');
      if (colorParam && colorSel) {
        var opt = [...colorSel.options].find(function (o) { return o.value.toUpperCase() === colorParam.toUpperCase(); });
        if (opt) colorSel.value = opt.value;
      }
    } catch (e) { /* URLSearchParams非対応環境では何もしない */ }

    /* 完了/エラーが表示されているページ(送信後の再表示)ではフォーカスを移動 */
    var success = page.querySelector('[data-xc-priority-success]');
    var error = page.querySelector('[data-xc-priority-error]');
    var target = success || error;
    if (target) {
      target.scrollIntoView({ block: 'center' });
      target.focus({ preventScroll: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
